import { render, staticRenderFns } from "./gc-popup-material-issue .vue?vue&type=template&id=61939c74"
import script from "./gc-popup-material-issue .vue?vue&type=script&lang=js"
export * from "./gc-popup-material-issue .vue?vue&type=script&lang=js"
import style0 from "./gc-popup-material-issue .vue?vue&type=style&index=0&id=61939c74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports